let scaleCode = '';
let leftDistance = '';
let topDistance = '';
import JSEncrypt from 'jsencrypt/bin/jsencrypt'
function seriesTurn(series,res){//series转换
  let timeArr=[];
  series.map(item=>{
  item.data.map(key=>{
  timeArr.push(key[0])
  })
  });
  timeArr=arrSort(unique(timeArr));
  let arri=[]
  for(let i=0;i<res.length;i++){
  let arrj=[]
  for(let j=0;j<timeArr.length;j++){
  arrj.push([timeArr[j],res[i].subDataMap[timeArr[j]]])
  }
  arri.push(arrj)
  }
  series.map((item,index)=>{
  item.data=arri[index]
  })
  return series
}
function arrSort(arr){//数组排序
  let newarr=[];
  arr.map(item=>{
  newarr.push(new Date(item.replace(/-/g, '/')).getTime())
  })
  newarr.sort(function(x, y){
  return x - y;
  });
  newarr=newarr.map(key=>{
  return getDateSeconds1(key) 
  })
  return newarr
}
function objSort(obj){//对象排序
  let arr=[];
  for(let key  in obj){
  arr.push({time:new Date(key.replace(/-/g, '/')).getTime(),value:obj[key]})
  }
  arr.sort(function(x, y){
  return x.time - y.time;
  });
  arr.map(item=>{
  item.time=getDateSeconds1(item.time)
  })
  return arr
}
function formatSeconds(value) {//小时转换成时分秒
  let result = parseInt(value*3600)
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

  let res = '';
  res += `${h}时`;
  res += `${m}分`;
  res += `${s}秒`;
  return res;
  }
function dataURLtoFile(dataurl, filename) {//将base64转换为文件
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
  u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {type:mime});
}
function getBase64Image (img) { //将图片转换为base64
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
  console.log(ext,img.width,img.height,'extimg')
  var dataURL = canvas.toDataURL("image/" + ext);
  // console.log(dataURL)
  return dataURL;
}
function getDateSeconds(){//获取当前时分秒
  var date=new Date();
  var month=date.getMonth()+1;
  var day=date.getDate();
  var hour=date.getHours();
  var minutes=date.getMinutes();
  var seconds= date.getSeconds();
  return date.getFullYear()+''+(month<10?"0"+month:month)+(day<10?"0"+day:day)+(hour<10?"0"+hour:hour)+(minutes<10?"0"+minutes:minutes)+(seconds<10?"0"+seconds:seconds);
}
function getDateSeconds1(str){//获取当前时分秒 有格式
  var date;
  if(str){
  date=new Date(str);
  }else{
  date=new Date();
  }
  var month=date.getMonth()+1;
  var day=date.getDate();
  var hour=date.getHours();
  var minutes=date.getMinutes();
  var seconds= date.getSeconds();
  return date.getFullYear()+'-'+(month<10?"0"+month:month)+'-'+(day<10?"0"+day:day)+' '+(hour<10?"0"+hour:hour)+':'+(minutes<10?"0"+minutes:minutes)+':'+(seconds<10?"0"+seconds:seconds);
}
function getDateSecondsAfter(str){//获取一小时后时分秒 有格式
  var date;
  if(str){
  date=new Date(new Date(str).getTime() + 60*60*1000);
  }else{
  date=new Date(new Date().getTime() + 60*60*1000);
  }
  var month=date.getMonth()+1;
  var day=date.getDate();
  var hour=date.getHours();
  var minutes=date.getMinutes();
  var seconds= date.getSeconds();
  return date.getFullYear()+'-'+(month<10?"0"+month:month)+'-'+(day<10?"0"+day:day)+' '+(hour<10?"0"+hour:hour)+':'+(minutes<10?"0"+minutes:minutes)+':'+(seconds<10?"0"+seconds:seconds);
}
function dateTransfor(){//本月今天
  var date=new Date();
  var month=date.getMonth()+1;
  var day=date.getDate();
  return date.getFullYear()+"-"+(month<10?"0"+month:month)+"-"+(day<10?"0"+day:day);
}
function dateTransfor1(){//上个月的今天
  var date=new Date((new Date()).getTime()-24 * 60 * 60 * 1000 * 30);
  var month=date.getMonth()+1;
  var day=date.getDate();
  return date.getFullYear()+"-"+(month<10?"0"+month:month)+"-"+(day<10?"0"+day:day);
}
function toChineseDate(str){
  return str.replace("-","年").replace("-","月").replace(" ","日 ");
  
}
function dateFormat(input, formatType){
  //  var formatType = formatType.toLowerCase();
  var startDate = parseToDate(input);
  if (startDate === false) {
  return input;
  }

  var day = startDate.getDate();
  if (day < 10)
  day = "0" + day.toString();
  var month = startDate.getMonth() + 1;
  var monthNoFill = month;
  month = month < 10 ? "0" + month.toString() : month;
  var hours = startDate.getHours();
  hours = hours < 10 ? "0" + hours.toString() : hours;
  var min = startDate.getMinutes();
  min = min < 10 ? "0" + min.toString() : min;
  var sec = startDate.getSeconds();
  sec = sec < 10 ? "0" + sec.toString() : sec;

  formatType = formatType.replace("YYYY", startDate.getFullYear()).replace("MM", month).replace("DD", day).replace("hh", hours).replace("mm", min).replace("ss", sec);
  if (formatType.indexOf("M") != -1) {
  //月份不补零的情况
  formatType = formatType.replace("M", monthNoFill)
  }
  return formatType;
}
// 时间戳转换成时间
function format(shijianchuo)
{
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth()+1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
}
function add0(m){return m<10?'0'+m:m }
function parseToDate(input){
  var startDate = input;
  if (startDate == null || startDate == "")
  return false;
  var inputDatatype = typeof (startDate);
  if (inputDatatype == "string") {
  startDate = startDate.replace(/-/g, "/");
  if (startDate.indexOf(".") > 0) {
  startDate = startDate.split(".")[0];
  }
  //兼容safari 转换格式为 2016/7/16
  startDate = new Date(startDate);
  }

  if (inputDatatype == "number") {
  if (startDate.toString().length == 10) {
  startDate = startDate * 1000;
  }
  startDate = new Date(parseInt(startDate));
  }
  if (startDate == "Invalid Date") {
  return false;
  }
  return startDate;
}

function text(){
  //// console.log(set)
}

//增加序号
function addOrder(arr){
  var endArr = arr
  for(let i=0;i<endArr.length;i++){
  endArr[i].order = i+1
  }
  return endArr
}
//道路数据
function changeRoadPointer(width,height,setObj,useRotate){
  let pileNumList = []
  // console.log(setObj)
  for(let i=0;i<setObj.middleLine.length;i++){
  pileNumList.push(setObj.middleLine[i].mileageNum)
  }
  let visualWidth = 100
  let visualHeight = 100
  
  let widthArea = width - visualWidth
  let heigthArea = height - visualHeight
  let leftLine = arrToArr(setObj.leftLine)
  let RightLine = arrToArr(setObj.rightLine)
  let midLine = arrToArr(setObj.middleLine)
  let xcordArr = arrToDArr(midLine,0)
  let ycordArr = arrToDArr(midLine,1)
  let xMaxCode = getMaxAMin(xcordArr,'max')
  let xMinCode = getMaxAMin(xcordArr,'min')
  let yMaxCode = getMaxAMin(ycordArr,'max')
  let yMinCode = getMaxAMin(ycordArr,'min')

  let rotateAngle = 0
    if(useRotate){
        rotateAngle = sessionStorage.getItem('rotateAngle') * 1
        rotateAngle = rotateAngle/180*Math.PI
    }
    if(rotateAngle){
        //对道路数据进行旋转
        for(let i=0;i<midLine.length;i++){
            midLine[i]=rotatePoint(midLine[i],[0,0],rotateAngle)
        }
        for(let i=0;i<leftLine.length;i++){
            leftLine[i]=rotatePoint(leftLine[i],[0,0],rotateAngle)
        }
        for(let i=0;i<RightLine.length;i++){
            RightLine[i]=rotatePoint(RightLine[i],[0,0],rotateAngle)
        }
    }
  // 获取x与y轴道路数据最大差距
  let xGap = (xMaxCode-xMinCode)>0?(xMaxCode-xMinCode):-(xMaxCode-xMinCode)
  let yGap = (yMaxCode-yMinCode)>0?(yMaxCode-yMinCode):-(yMaxCode-yMinCode)
  // 获取x与y轴对于canvas高宽的比例
  let xScale = xGap/widthArea
  let yScale = yGap/heigthArea
  //设置页面canvas比列大小
  scaleCode = xScale>yScale ? xScale : yScale
  localStorage.setItem('scaleCode',scaleCode)
  // 获取缩放后的道路数据
  let midScaledLine = roadScale(midLine,scaleCode)
  let leftScaledLine = roadScale(leftLine,scaleCode)
  let rightScaledLine = roadScale(RightLine,scaleCode)
  // 获取缩放后的道路数据中x与y轴最小值
  let scaledXMinCode = getMaxAMin(arrToDArr(midScaledLine,0),'min').toFixed(2)
  let scaledXMaxCode = getMaxAMin(arrToDArr(midScaledLine,0),'max').toFixed(2)
  let scaledYMinCode = getMaxAMin(arrToDArr(midScaledLine,1),'min').toFixed(2)
  let scaledYMaxCode = getMaxAMin(arrToDArr(midScaledLine,1),'max').toFixed(2)
  let addX = width/2 - (scaledXMaxCode - scaledXMinCode)/2
  let addY = height/2 - (scaledYMaxCode - scaledYMinCode)/2
  // 缩放后的道路数据中x与y轴最小值移动到左边与上边的差距值
  leftDistance = visualHeight/2 - scaledXMinCode + addX
  topDistance = visualHeight/2 - scaledYMinCode + addY
  localStorage.setItem("leftDistance",leftDistance);
  localStorage.setItem("topDistance",topDistance);
  // 转换缩放后的道路的数据
  let changedMid = changedRoad(midScaledLine,leftDistance,topDistance)
  let changedLeft = changedRoad(leftScaledLine,leftDistance,topDistance)
  let changedRight = changedRoad(rightScaledLine,leftDistance,topDistance)
  // let returnObj = {
  // mid: changedMid,
  // left: changedLeft,
  // right: changedRight
  // }
  let returnObj = [changedLeft,changedMid,changedRight,pileNumList]
  return [returnObj,scaleCode]
}

//单点坐标进行旋转
function rotatePoint(point, center, radians) {
  let distance = Math.sqrt(Math.pow(point[0]*1-center[0]*1,2)+Math.pow(point[1]*1-center[1]*1,2))
  let angle = Math.atan2(point[1]*1-center[1]*1,point[0]*1-center[0]*1)
  const cos = Math.cos(radians+angle);
  const sin = Math.sin(radians+angle);
  const nx = cos * distance + center[0]*1;
  const ny = sin * distance + center[1]*1;
  return [nx,ny];
  }

//非标道路数据转化
function changeUnRoadPointer(width, height, setObj) {
  let pileNumList = [];
  for (let i = 0; i < setObj.roadVertex.length; i++) {
  pileNumList.push(setObj.roadVertex[i]);
  }
  let visualWidth = 50;
  let visualHeight = 50;
  let widthArea = width - visualWidth;
  let heigthArea = height - visualHeight;
  let roadVertex = unarrToArr(setObj.roadVertex);
  let roadBlocks = unarrToArr1(setObj.roadBlocks);
  let sectionVertex = unarrToArr(setObj.sectionVertex);
  let safeSectionVertex = unarrToArr(setObj.safeSectionVertex);
  let safeRoadBlocks = unarrToArr1(setObj.safeRoadBlocks);
  // console.log(roadVertex,roadBlocks,sectionVertex,safeSectionVertex,safeRoadBlocks,'changedMid')
  let xcordArr = arrToDArr(roadVertex, 0);
  let ycordArr = arrToDArr(roadVertex, 1);
  
  let xMaxCode = getMaxAMin(xcordArr, "max");
  let xMinCode = getMaxAMin(xcordArr, "min");
  let yMaxCode = getMaxAMin(ycordArr, "max");
  let yMinCode = getMaxAMin(ycordArr, "min");
  // 获取x与y轴道路数据最大差距
  let xGap =
  xMaxCode - xMinCode > 0 ? xMaxCode - xMinCode : -(xMaxCode - xMinCode);
  let yGap =
  yMaxCode - yMinCode > 0 ? yMaxCode - yMinCode : -(yMaxCode - yMinCode);
  // 获取x与y轴对于canvas高宽的比例
  let xScale = xGap / (widthArea - 50);
  let yScale = yGap / (heigthArea - 50);
  //设置页面canvas比列大小
  scaleCode = xScale > yScale ? xScale : yScale;
  // scaleCode=1;
  localStorage.setItem("scaleCode", scaleCode);
  // 获取缩放后的道路和障碍区数据
 
  let midScaledLine = roadScale(roadVertex, scaleCode);
  let barScaledLine = roadScale1(roadBlocks, scaleCode);
  let workScaledLine = roadScale(sectionVertex, scaleCode);
  let safeSecScaledLine = roadScale(safeSectionVertex, scaleCode);
  let safeBloScaledLine = roadScale1(safeRoadBlocks, scaleCode);
  // 获取缩放后的道路数据中x与y轴最小值
  let scaledXMinCode = getMaxAMin(
  arrToDArr(midScaledLine, 0),
  "min"
  ).toFixed(2);
  let scaledXMaxCode = getMaxAMin(
  arrToDArr(midScaledLine, 0),
  "max"
  ).toFixed(2);
  let scaledYMinCode = getMaxAMin(
  arrToDArr(midScaledLine, 1),
  "min"
  ).toFixed(2);
  let scaledYMaxCode = getMaxAMin(
  arrToDArr(midScaledLine, 1),
  "max"
  ).toFixed(2);
  let addX = width / 2 - (scaledXMaxCode - scaledXMinCode) / 2;
  let addY = height / 2 - (scaledYMaxCode - scaledYMinCode) / 2;
  // 缩放后的道路数据中x与y轴最小值移动到左边与上边的差距值
  leftDistance = visualHeight / 2 - scaledXMinCode + addX;
  topDistance = visualHeight / 2 - scaledYMinCode + addY;
  console.log(scaleCode,leftDistance,topDistance,'changedMid')
  localStorage.setItem("leftDistance", leftDistance);
  localStorage.setItem("topDistance", topDistance);
  // 转换缩放后的道路的数据
  let changedMid = changedRoad(
  midScaledLine,
  leftDistance,
  topDistance
  );
  
  let changedBar = changedRoad1(
  barScaledLine,
  leftDistance,
  topDistance
  );
  let changedWork = changedRoad(
  workScaledLine,
  leftDistance,
  topDistance
  );
  let changedSafeWork = changedRoad(
  safeSecScaledLine,
  leftDistance,
  topDistance
  );
  let changedSafeBlock = changedRoad1(
  safeBloScaledLine,
  leftDistance,
  topDistance
  );
  let returnObj = [
  changedMid,
  pileNumList,
  changedBar,
  changedWork,
  changedSafeWork,
  changedSafeBlock,
  ];
  // console.log(returnObj, scaleCode)
  return [returnObj, scaleCode];
}

// // 对单个数据进行坐标转换
function onePointerChange(pointer,useRotate){
  let rotateAngle = 0 
  if(useRotate){
      rotateAngle = sessionStorage.getItem('rotateAngle')
      if(!rotateAngle){
              rotateAngle = 0
          }
      rotateAngle = -rotateAngle/180*Math.PI
  }
  if(rotateAngle){
      pointer = rotatePoint(pointer,[0,0],rotateAngle)
  }
  // console.log(pointer[0],pointer[1])
  scaleCode=scaleCode||(localStorage.getItem("scaleCode")*1);
  leftDistance=leftDistance||(localStorage.getItem("leftDistance")*1);
  topDistance=topDistance||(localStorage.getItem("topDistance")*1);
  let setNum = pointer
  setNum = [setNum[0]*1,-setNum[1]*1]

  setNum = [setNum[0]/(scaleCode*1),setNum[1]/(scaleCode*1)]
  setNum = [setNum[0]+(leftDistance*1),setNum[1]+(topDistance*1)]
  return setNum
}

//有道路数据情况下散点坐标进行转换
function haveRoadChangePoints(setChangeList){
  let changeReturn = arrToArr(setChangeList)
  let changeScale = roadScale(changeReturn,scaleCode)
  let changeXY = changedRoad(changeScale,leftDistance,topDistance)
  return changeXY
}

//获取坐标数组
function arrToArr (arr){
  //// console.log(arr)
  let setArr = []
  for(let i=0;i<arr.length;i++){
  setArr.push([arr[i].xcord,-arr[i].ycord])
  }
  return setArr
}
//获取非标道路坐标数组
function unarrToArr(arr) {
  //转换区块
  if(!arr){
  arr=[]
  }
  let setArr = [];
  for (let i = 0; i < arr.length; i++) {
  setArr.push([arr[i].x, -arr[i].y]);
  }
  return setArr;
  }
function unarrToArr1(arr) {
  //转换障碍
  if(!arr){
  arr=[]
  }
  let setArr = [];
  for (let i = 0; i < arr.length; i++) {
  let setArr1 = [];
  for (let j = 0; j < arr[i].points.length; j++) {
  setArr1.push({ x: arr[i].points[j].x, y: -arr[i].points[j].y });
  }
  setArr.push(setArr1);
  }
  return setArr;
  }
//道路数据进行缩放
function roadScale(arr,code){
  let setArr= []
  code=scaleCode||localStorage.getItem("scaleCode")*1;
  for(let i=0;i<arr.length;i++){
  setArr.push([arr[i][0]/code,arr[i][1]/code])
  }
  return setArr
}
//非标道路数据进行缩放
function roadScale1(arr, code) {
  let setArr = [];
  for (let i = 0; i < arr.length; i++) {
  let setArr1 = [];
  for (let j = 0; j < arr[i].length; j++) {
  setArr1.push({ x: arr[i][j].x / code, y: arr[i][j].y / code });
  }
  setArr.push(setArr1);
  }
  return setArr;
}
function changedRoad(arr,x,y){
  let setArr = []
  x=x||localStorage.getItem("leftDistance")*1;
  y=y||localStorage.getItem("topDistance")*1;
  for(let i=0;i<arr.length;i++){
  setArr.push([arr[i][0]+x,arr[i][1]+y])
  }
  return setArr
}
//非标道路数据转化
function changedRoad1(arr, x, y) {
  let setArr = [];
  for (let i = 0; i < arr.length; i++) {
  let setArr1 = [];
  for (let j = 0; j < arr[i].length; j++) {
  setArr1.push({ x: arr[i][j].x * 1 + x, y: arr[i][j].y * 1 + y });
  }
  setArr.push(setArr1);
  }
  return setArr;
}
//获取坐标数组
function arrToDArr (arr,type){
  let setArr = []
  for(let i=0;i<arr.length;i++){
  setArr.push(arr[i][type])
  }
  return setArr
}

//获取坐标值的最大值与最小值
function getMaxAMin(arr,type){
  if(type == 'max'){
  return Math.max.apply(Math,arr)
  }else if(type == 'min'){
  return Math.min.apply(Math,arr)
  }
}

//获取数组中与目标值最接近的数
function MaxFn (str, arr) {
  let list = []
  arr.forEach((el) => {
  // 1、在所有时间里面找出小于当前时间
  if (el < str) {
  // 2、把所有小于当前时间的时间整合到数组
  list.push(el)
  }
  })
  // 3、数组从小到大排序
  list.sort(function(a,b){return a-b;});
  // 4、从排序的数组里面获取最后一位
  return list.length
}
//升序排列
function compare(property) {
  return function (a, b) {
  var value1 = a[property];
  var value2 = b[property];
  return value1 - value2;
  }
}
//降序排列
function unCompare(property) {
  return function (a, b) {
  var value1 = a[property];
  var value2 = b[property];
  return value2 - value1;
  }
}

function sliceArr(start,end,arr){
  //// console.log('jjjjj')
  return arr.slice(start,end)
}

//根据数组生产path
function setPathValue(arr){
  let pathV = 'M'+' '+arr[0][0] +' '+arr[0][1]+' '
  for(let i=1;i<arr.length;i++){
  pathV += 'L'+' '+arr[i][0]+' '+arr[i][1]+' '
  }
  pathV = pathV + ' ' + 'z'
  return pathV
}

//与当前日期相差
function getNowDataNum(data){
  let newD = Date.parse(new Date())
  let getD = Date.parse(new Date(data))
  let numD = (newD - getD)/1000
  let unit = numD>0?'超时':''
  let getNum = Math.floor(Math.abs(numD)/(24*60*60))
  return unit + getNum + '天'

}

//数组去重
function unique(arr) {
  return Array.from(new Set(arr))
}
//时间戳转日期格式
function timestampToTime(timestamp) {
  var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
  var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
  
  let strDate = Y+M+D+h+m+s;
  return strDate;
}
// 值在数组中的位置
function valueInArr(data,list){
  let code = 0
  for(let i=0;i<list.length-1;i++){
  if(data>=list[i] && data<=list[i+1]){
  code = i
  return code
  }
  }
  
}

function genID(length){
 return Number(Math.random().toString().substr(3,length) + Date.now()).toString(36);
}

//计算多边形面积
function calculateArea(arr){
  let size = arr.length;
  let area = 0;
  if (size >= 3) {
  for (let i = 0; i < size; i++) {
  if (i == size - 1) {
  area += (arr[i].x * arr[0].y - arr[i].y * arr[0].x);
  } else {
  area += (arr[i].x * arr[i+1].y - arr[i].y * arr[i+1].x);
  }
  }
  area = Math.abs(area) / 2;
  area = area.toFixed(2)
  }
  return area
}

//包含对象的数组去重
function uniqueObj(arr){
  let result = {};
  let finalResult=[];
  for(let i=0;i<arr.length;i++){
  result[arr[i].code]=arr[i];
  //arr[i].code,达到去重效果,且这里必须知晓"code"或是其他键名
  }
  //现在result内部都是不重复的对象了，只需要将其键值取出来转为数组即可
  for(let item in result){
  finalResult.push(result[item]);
  }
  return finalResult;
}

//小数点小时换成时分
function secondToHM(value){
  let _value=value*3600
  let result = parseInt(_value)
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));

  let res = '';
  res += `${h}小时`;
  res += `${m}分钟`;
  return res
}
//获取几天前几天后的日期
function getDay(day,time){
  var today = new Date();
  if(time){
  today = new Date(time)
  }
  var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth()+1;
  var tDate = today.getDate();
  tMonth = tMonth<10?'0'+tMonth:tMonth;
  tDate = tDate<10?'0'+tDate:tDate;
  return tYear+"-"+tMonth+"-"+tDate;
 }
 //获取几分钟前几分钟后的日期
function getMinite(minite,time){
  var today = new Date();
  if(time){
  today = new Date(time)
  }
  var targetday_milliseconds=today.getTime() + 1000*60*minite;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth()+1;
  var tDate = today.getDate();
  var tHour = today.getHours();
  var tMinute = today.getMinutes();
  var tSecond = today.getSeconds();
  tMonth = tMonth<10?'0'+tMonth:tMonth;
  tDate = tDate<10?'0'+tDate:tDate;
  tHour = tHour<10?'0'+tHour:tHour;
  tMinute = tMinute<10?'0'+tMinute:tMinute;
  tSecond = tSecond<10?'0'+tSecond:tSecond;
  return tYear+"-"+tMonth+"-"+tDate+' '+tHour+":"+tMinute+":"+tSecond;
 }
 //将url地址转换成base64
 function urlToFile(src){
    var c = document.createElement("canvas");
    var cxt=c.getContext("2d");
    var img=new Image();
    img.setAttribute("crossOrigin",'Anonymous');
    img.src=src
    img.onload=function(){
        c.width = this.width;
        c.height = this.height;
        cxt.drawImage(img, 0, 0, this.width, this.height) // 在canvas上绘制图片
        var dataURL = compress(img,this.width,this.height,0.8);
        return dataURL
    }
  }

  function compress(img, width, height, ratio) {
  // img可以是dataURL或者图片url
  /* 如果宽度大于 750 图片太大 等比压缩  */
//   if(width > 750){
//   var ratio = width/height;
//   width = 750;
//   height = 750/ratio;
//   }
  var canvas, ctx, img64;
  canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  /* canvas.toDataURL(mimeType（图片的类型）, qualityArgument（图片质量）) */
  img64 = canvas.toDataURL("image/jpeg", ratio);
  return img64; // 压缩后的base64串
  }
  //RSA加密
  function encryption(password){
    let encryptor = new JSEncrypt() // 新建JSEncrypt对象
    let publicKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6Iz1+NlACE059gYjiG6kv8hrLyfGv0OANa3tSavFOkhg7Pj4m/C4V3GiB3+85S0Q8WIVhGX1oOWndGgRDnWlh+89YJOL5zEtj6REO2D5yfHUc8Rwu/fDuxzNjCDnEhJDrWXoSUJVZzym74UFnuB2IJxEIE+4HNpB2+zSpyXyCfQIDAQAB`  //把之前生成的贴进来，实际开发过程中，可以是后台传过来的
    encryptor.setPublicKey(publicKey) // 设置公钥
    let rsaPassWord = encryptor.encrypt(password) // 对需要加密的数据进行加密
    return rsaPassWord  //得到加密后的数据
  }
  //RSA解密
  // function decrypt(secretWord){
  //   let decrypt = new JSEncrypt() // 新建JSEncrypt对象
  //   let privateKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDHGBAi30CuorD71ddAY5Pj80a2
  //   FinTK6CJrX3LJZ5FTxJrQdzxbwDVB2mDVgspU5oz7X03TzgWFKkkJm2b4g9G00sA
  //   +G9oeGaR+rpFaoDr4BxW+AUd6V1Ps/OkTaLc473XOA0aYTRIwo1Ob3pTJd9Za90e
  //   +NRk0c07Vb/mcr0w1QIDAQAB`
  //   decrypt.setPrivateKey(privateKey)
  //   let getWord = decrypt.decrypt(secretWord) // 解密
  //   return getWord // 输出，可以在控制台看到解密得到的字段
  // }
export {
  dateFormat,
  text,
  addOrder,
  changeRoadPointer,
  MaxFn,
  compare,
  unCompare,
  sliceArr,
  haveRoadChangePoints,
  onePointerChange,
  setPathValue,
  getNowDataNum,
  unique,
  dateTransfor,
  dateTransfor1,
  toChineseDate,
  getDateSeconds,
  getDateSeconds1,
  dataURLtoFile,
  getBase64Image,
  getDateSecondsAfter,
  formatSeconds,
  objSort,
  arrSort,
  seriesTurn,
  unarrToArr1,
  unarrToArr,
  changedRoad1,
  roadScale1,
  changeUnRoadPointer,
  timestampToTime,
  valueInArr,
  format,
  genID,
  calculateArea,
  uniqueObj,
  secondToHM,
  getDay,
  getMinite,
  urlToFile,
  compress,
  encryption,
  rotatePoint,
}